// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "templates/assets/" + "946e8d8eac296253aaf1" + "." + chunkId + ".js";
};